import React from "react";
import { Link } from "react-router-dom";
import "./Growth.css";
import Layout from "../layout/layout";
import mr from "../../images/mr.png";
import mm2 from "../../images/mm2.png";
import jf from "../../images/jf.png";
import rg from "../../images/rg.png";
import kd from "../../images/kd.png";
import rm from "../../images/rm.png";

function Growth() {
  return (
    <Layout>
      <div className="leadership-container">
        <div className="leadership-hero"></div>{" "}
        <h1 id="leadership-head">The Leadership Behind Reszko Nation</h1>
        <div className="leadership-content-container">
          <div className="leadership-content-container-title"></div>{" "}
          <div className="leadership-national">
            <div
              id="leader-container"
              className="leadership-content-container-mr"
            >
              <img className="leader-pic-mr" src={mr}></img>
              <div className="leader-info">
                <h1>Matthew Reszko</h1>
                <h2 className="leader-title">National Director</h2>
                <p className="leader-bio">
                  With a strong foundation in leadership and client service,
                  [Name] brings discipline, drive, and strategic focus to the
                  Reszko Nation team within MedaHealth. Known for a
                  results-oriented mindset and commitment to excellence,
                  [he/she/they] specializes in helping individuals and families
                  navigate complex health and life insurance solutions with
                  clarity and confidence.
                  <br></br>
                  <br></br>
                  Backed by MedaHealth’s national platform and partnerships with
                  leading carriers, [Name] is dedicated to delivering
                  personalized guidance tailored to each client’s unique goals.
                  Beyond production, [he/she/they] is passionate about
                  mentorship and professional development, contributing to the
                  culture of growth and accountability that defines Reszko
                  Nation.
                </p>
              </div>
            </div>
          </div>
          <hr className="leadership-divider"></hr>
          <div className="leadership-regional">
            <div
              id="leader-container"
              className="leadership-content-container-rg"
            >
              <img className="leader-pic-rg" src={rg}></img>
              <div className="leader-info">
                <h1>Randy Groesbeck</h1>
                <h2 className="leader-title">Regional Director</h2>
                <p className="leader-bio">
                  {" "}
                  Backed by MedaHealth’s national platform and partnerships with
                  leading carriers, [Name] is dedicated to delivering
                  personalized guidance tailored to each client’s unique goals.
                  Beyond production, [he/she/they] is passionate about
                  mentorship and professional development, contributing to the
                  culture of growth and accountability that defines Reszko
                  Nation.
                </p>
              </div>
            </div>
          </div>
          <hr className="leadership-divider"></hr>
          <div className="leadership-divisional">
            <div
              id="leader-container-div"
              className="leadership-content-container-dd"
            >
              <img className="leader-pic" src={mm2}></img>
              <div className="leader-info-div">
                <h1>Mariah Menendez</h1>
                <h3 className="leader-title">Divisional Director</h3>
                <p className="leader-bio">Words about the leader.</p>
              </div>
            </div>
            <div
              id="leader-container-div"
              className="leadership-content-container-dd"
            >
              <img className="leader-pic" src={jf}></img>
              <div className="leader-info-div">
                <h1>Jerickson Fedrick</h1>
                <h3 className="leader-title">Divisional Director</h3>
                <p className="leader-bio">Words about the leader.</p>
              </div>
            </div>
            <div
              id="leader-container-div"
              className="leadership-content-container-dd"
            >
              <img className="leader-pic" src={kd}></img>
              <div className="leader-info-div">
                <h1>Karalynda DeJesus</h1>
                <h3 className="leader-title">Divisional Director</h3>
                <p className="leader-bio">Words about the leader.</p>
              </div>
            </div>
            <div
              id="leader-container-div"
              className="leadership-content-container-dd"
            >
              <img className="leader-pic" src={rm}></img>
              <div className="leader-info-div">
                <h1>Ryan Mansouri</h1>
                <h3 className="leader-title">Divisional Director</h3>
                <p className="leader-bio">Words about the leader.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Growth;
